module.exports = __webpack_public_path__ + "media/images/area/feature/tohoku/related/th/4-394d2c0a31fac35f3b00949ab6900f76.jpg";